import { createClient } from "@supabase/supabase-js";

// Replace these with your actual Supabase URL and public key
// Use import.meta.env for client-side (Vite), process.env for server-side (Node.js)
// @ts-ignore - import.meta is available in Vite but TypeScript server config doesn't recognize it
const supabaseUrl = (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_SUPABASE_URL) 
  || (typeof process !== 'undefined' && process.env?.VITE_SUPABASE_URL)
  || "YOUR_SUPABASE_URL";
// @ts-ignore - import.meta is available in Vite but TypeScript server config doesn't recognize it
const supabaseAnonKey = (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_SUPABASE_ANON_KEY)
  || (typeof process !== 'undefined' && process.env?.VITE_SUPABASE_ANON_KEY)
  || "YOUR_SUPABASE_ANON_KEY";

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: 'public'
  }
});

export const setupSessionRefresh = async (): Promise<
  (() => void) | undefined
> => {
  try {
    // Get the current session first
    const { data, error } = await supabase.auth.getSession();

    if (error || !data.session) {
      console.log("No active session found, skipping session refresh setup");
      return undefined;
    }

    // Setup a refresh interval (e.g., every 23 hours to avoid token expiration)
    const REFRESH_INTERVAL = 23 * 60 * 60 * 1000; // 23 hours in milliseconds

    const refreshSession = async () => {
      const { data, error } = await supabase.auth.refreshSession();
      if (error) {
        console.error("Error refreshing session:", error);
      } else {
        console.log("Session refreshed successfully");
      }
    };

    // Set up interval
    const interval = setInterval(refreshSession, REFRESH_INTERVAL);
    console.log("Session refresh interval set up successfully");

    // Return cleanup function
    return () => {
      clearInterval(interval);
      console.log("Session refresh interval cleared");
    };
  } catch (error) {
    console.error("Failed to setup session refresh:", error);
    return undefined;
  }
};
